import { render, staticRenderFns } from "./CarouselFramedSlide.vue?vue&type=template&id=7a225fe4&"
import script from "./CarouselFramedSlide.vue?vue&type=script&lang=js&"
export * from "./CarouselFramedSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports